import { HeaderSidebar } from "../../../components/Header/HeaderSidebar";
import { Field, Form, Formik } from "formik"
import { useEffect, useState } from "react"
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { TextareaAutosize } from "@mui/material";
import { getIntroForm } from "../../../services/autofillService";
import { getClassName } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { Step } from "../../../components/Step/Step";
import { questions, videos } from "../../../content/intro";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Oval } from "react-loader-spinner"
import { submitIntro } from "../../../services/answersService";
import { validateNoValue } from "../../../utils/validation";

export const Intro = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [initialValues, setInitialValues] = useState({
        companyName: '',
        problemStatement: '',
        problemSolution: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 2) {
            dispatch(setProgress(3))
        } else if (activeStep === 1) {
            dispatch(setProgress(0))
        }
    }

    const handleDownClick = (errors) => {
        if(Object.keys(errors).length !== 0) return;
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(3))
        } else if (activeStep === 1) {
            dispatch(setProgress(6))
        }
    }

    const handleSubmit = (values, errors) => {
        setIsLoading(true);
        submitIntro(values).then(response => {
            setIsLoading(false);
            navigate("/flow/purpose");
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        })
    };

    useEffect(() => {
        dispatch(setProgress(0));
        getIntroForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.log(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <Form className="form">
                            <section className="flex flex-col items-center justify-center w-full h-full">
                                <Step className={getClassName(0, activeStep)} question={questions.companyName} url={videos.companyNameVideo.url}>
                                    <Field
                                        id="companyName"
                                        name="companyName"
                                        placeholder="Enter your company name here."
                                        className="has-border-bottom"
                                        validate={(value) => validateNoValue(value)} />
                                    {errors.companyName && touched.companyName && (
                                        <div className="text-xs text-[red] border border-solid border-red p-4 mt-2">{errors.companyName}</div>
                                    )}
                                </Step>
                                <Step className={getClassName(1, activeStep)} question={questions.problemStatement} url={videos.problemStatementVideo.url}>
                                    <Field
                                        id="problemStatement"
                                        name="problemStatement"
                                        placeholder="Write problem statement here."
                                        className="has-border-bottom"
                                        validate={(value) => validateNoValue(value)}
                                        as={TextareaAutosize}
                                    />
                                    {errors.problemStatement && touched.problemStatement && (
                                        <div className="text-xs text-[red] border border-solid border-red p-4 mt-2">{errors.problemStatement}</div>
                                    )}
                                </Step>
                                <Step className={getClassName(2, activeStep)} question={questions.problemSolution} url={videos.problemSolutionVideo.url}>
                                    <Field
                                        id="problemSolution"
                                        name="problemSolution"
                                        placeholder="Write solution here."
                                        className="has-border-bottom"
                                        validate={(value) => validateNoValue(value)}
                                        as={TextareaAutosize}
                                    />
                                    {errors.problemSolution && touched.problemSolution && (
                                        <div className="text-xs text-[red] border border-solid border-red p-4 mt-2">{errors.problemSolution}</div>
                                    )}
                                </Step>
                            </section>
                            <Buttons link="/introduction">
                                <UpButton onClick={handleUpClick} disabled={activeStep === 0} />
                                {(activeStep === 2) ? (
                                    <button type="submit" className="btn yellow-cta">
                                        {isLoading ? <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        /> : (
                                            <span>
                                                Next
                                            </span>
                                        )}
                                    </button>
                                ) : (
                                    <DownButton onClick={() => handleDownClick(errors)} disabled={activeStep === 2} />
                                )}
                            </Buttons>
                        </Form>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Intro" />
        </>
    );
}